module.exports = __webpack_public_path__ + "web/img/essence-zh.9b811dc2.png";